// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetFolderJsonRequest from '../contract/GetFolderJsonRequest';

export default function getFolderJsonRequest(data: GetFolderJsonRequest): GetFolderJsonRequest {
    const result: GetFolderJsonRequest = {
        __type: 'GetFolderJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
